<template>
  <v-container>
    <loading-spinner v-if="loading"> </loading-spinner>
    <v-row v-else>
      <v-col cols="12" v-for="(item, i) in unfinished" :key="i">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="auto">
                <user-avatar
                  :size="75"
                  :user="item.user"
                  borderColor="performance"
                  color="performance"
                  cssClass="mx-4 text-h4"
                  textColor="white"
                ></user-avatar>
              </v-col>
              <v-col>
                <div class="text-h6 secondarytext--text mb-3">
                  You never marked your
                  {{ item.startDate | monthDate }} {{ item.name }} meeting as
                  completed.
                </div>
                <v-btn
                  outlined
                  color="performance"
                  :to="`/meetings/${item.definitionId}/start`"
                >
                  Let's Fix This
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "UnfinishedCheckInQueue",
  props: {},
  components: {},
  data: () => ({ loading: false }),
  computed: {
    ...mapGetters({
      unfinished: "checkin/unfinished",
      profile: "profile/profile"
    })
  },
  created() {
    this.loading = true;
    this.$store
      .dispatch("checkin/getUnfinishedCheckIns")
      .catch(error => {
        this.logError(error);
        this.$root.$alert(
          "Error Occurred",
          "An error occured while loading your meetings."
        );
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {}
};
</script>
